import { motion } from 'framer-motion';
import React from 'react';
export function VendorWarning() {
    return (
        <motion.div
            className="mt-4 ms-4 p-4 rounded-3"
            style={{
                backgroundColor: 'var(--accent-soft)',
                border: '1px solid var(--hairline)',
                borderLeft: '5px solid var(--accent)'
            }}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ type: "spring", stiffness: 300, damping: 25 }}
        >
            <div className="d-flex align-items-start">
                <i
                    className="fas fa-exclamation-triangle me-3 mt-1"
                    style={{ color: 'var(--accent)', fontSize: '1.3rem' }}
                />
                <div style={{ flex: 1 }}>
                    <h6
                        className="mb-2"
                        style={{
                            color: 'var(--ink)',
                            fontWeight: '700'
                        }}
                    >
                        No Questions Have Been Added Yet
                    </h6>
                    <p
                        className="mb-2"
                        style={{
                            color: 'var(--ink-soft)',
                            fontSize: '0.9rem',
                            lineHeight: '1.6'
                        }}
                    >
                        This might be due to a failure in adding the questions, an issue with the template, or the template being incomplete.
                    </p>
                    <small style={{ color: 'var(--ink)' }}>
                        <i className="fas fa-arrow-right me-2" style={{ color: 'var(--accent)', fontSize: '0.7rem' }}></i>
                        Please review the situation and coordinate with your team leader or manager if necessary.
                    </small>
                </div>
            </div>
        </motion.div>
    );
}